<template>

	<app-boards board-key="faq"></app-boards>

</template>

<script>
import AppBoards from "@/components/boards/appBoards";
export default {
	name: "faq",
	components: {AppBoards}
}
</script>

<style scoped>

</style>